import api from "@/services/api";

export default {
  namespaced: true,

  state: () => ({
    margenBruto: null,
    sensibilidad: null,
    cashFlow: null,
    dashboard: null,
    analisisKilos: null,
    crecimientoPatrimonial: null,
    loading: false,
    error: null,
  }),

  getters: {
    margenBruto: (s) => s.margenBruto,
    sensibilidad: (s) => s.sensibilidad,
    cashFlow: (s) => s.cashFlow,
    dashboard: (s) => s.dashboard,
    analisisKilos: (s) => s.analisisKilos,
    crecimientoPatrimonial: (s) => s.crecimientoPatrimonial,
    loading: (s) => s.loading,
    error: (s) => s.error,
  },

  mutations: {
    setMargenBruto(state, data) {
      state.margenBruto = data;
    },
    setSensibilidad(state, data) {
      state.sensibilidad = data;
    },
    setCashFlow(state, data) {
      state.cashFlow = data;
    },
    setDashboard(state, data) {
      state.dashboard = data;
    },
    setAnalisisKilos(state, data) {
      state.analisisKilos = data;
    },
    setCrecimientoPatrimonial(state, data) {
      state.crecimientoPatrimonial = data;
    },
    setLoading(state, v) {
      state.loading = v;
    },
    setError(state, v) {
      state.error = v;
    },
    clearState(state) {
      state.margenBruto = null;
      state.sensibilidad = null;
      state.cashFlow = null;
      state.dashboard = null;
      state.analisisKilos = null;
      state.crecimientoPatrimonial = null;
      state.error = null;
    },
  },

  actions: {
    async getMargenBruto({ commit }, params = {}) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const { data } = await api.get("/erp/margen-bruto", { params });
        commit("setMargenBruto", data);
        return data;
      } catch (e) {
        commit("setError", e.response?.data?.detail || e.message);
        throw e;
      } finally {
        commit("setLoading", false);
      }
    },

    async getSensibilidad({ commit }, params = {}) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const { data } = await api.get("/erp/sensibilidad", { params });
        commit("setSensibilidad", data);
        return data;
      } catch (e) {
        commit("setError", e.response?.data?.detail || e.message);
        throw e;
      } finally {
        commit("setLoading", false);
      }
    },

    async getCashFlow({ commit }, params = {}) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const { data } = await api.get("/erp/cash-flow", { params });
        commit("setCashFlow", data);
        return data;
      } catch (e) {
        commit("setError", e.response?.data?.detail || e.message);
        throw e;
      } finally {
        commit("setLoading", false);
      }
    },

    async getDashboard({ commit }, params = {}) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const { data } = await api.get("/erp/dashboard", { params });
        commit("setDashboard", data);
        return data;
      } catch (e) {
        commit("setError", e.response?.data?.detail || e.message);
        throw e;
      } finally {
        commit("setLoading", false);
      }
    },

    async getAnalisisKilos({ commit }, params = {}) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const { data } = await api.get("/erp/analisis-kilos", { params });
        commit("setAnalisisKilos", data);
        return data;
      } catch (e) {
        commit("setError", e.response?.data?.detail || e.message);
        throw e;
      } finally {
        commit("setLoading", false);
      }
    },

    async getCrecimientoPatrimonial({ commit }, params = {}) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const { data } = await api.get("/erp/crecimiento-patrimonial", {
          params,
        });
        commit("setCrecimientoPatrimonial", data);
        return data;
      } catch (e) {
        commit("setError", e.response?.data?.detail || e.message);
        throw e;
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
